import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document
	.querySelectorAll("body:not(.is-admin) .popup-gallery ")
	.forEach(function (item) {
		item.querySelectorAll('.popup-gallery__close ,.popup-gallery__overlay').forEach(function (btn) {
			btn.addEventListener('click',()=>{
				item.classList.remove('_animate')
				setTimeout(()=>{
					item.classList.remove('_display')
				},500)
			})
		})
		
	});

document
	.querySelectorAll("body:not(.is-admin) [data-popupslider]")
	.forEach(function (item) {
		item.addEventListener('click',()=>{
			const popup = document.querySelector(item.dataset.popupslider.split("|")[0]);
			if(popup){
				popup.classList.add('_display')
				setTimeout(()=>{
					popup.classList.add('_animate')
				},100)
				if(popup.querySelector('.popup-gallery__swiper').swiper){
					popup.querySelector('.popup-gallery__swiper').swiper.destroy()
				}
				
				new Swiper((popup.querySelector('.swiper')), {
			slidesPerView: 1,
			spaceBetween: 15,
			loop: true,
			pagination: {
				el: popup.querySelector(".swiper-pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") ); 
				}
			},
			navigation: {
				nextEl: popup.querySelector(".swiper-next"),
				prevEl: popup.querySelector(".swiper-prev"),
			},
		});
				popup.querySelector('.popup-gallery__swiper').swiper.slideTo(item.dataset.popupslider.split("|")[1]);
				popup.querySelector('.popup-gallery__swiper').swiper.update()
			}
		})
	})